import { render, staticRenderFns } from "./whats-methods.vue?vue&type=template&id=6f34cc71&"
import script from "./whats-methods.vue?vue&type=script&lang=js&"
export * from "./whats-methods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports